/*
  Hidden Scotland — fast add to cart.

  Turns the bespoke hs-* product forms into AJAX adds so the page never
  reloads: submit -> POST /cart/add.js -> refresh the header cart bubble
  -> open the cart drawer if the theme has one, otherwise show an inline
  "Added" confirmation.

  Two deliberate safety rules:
    1. Forms inside Dawn's own <product-form> element are skipped, because
       Dawn already AJAX-adds those. Binding both would add twice.
    2. If anything goes wrong the form is submitted normally, so a sale can
       never be blocked by this script.
*/
(function () {
  'use strict';

  var ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';
  var BOUND = 'hsCartBound';

  function bubbleEl() {
    return document.getElementById('cart-icon-bubble');
  }

  function drawerEl() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }

  function notificationEl() {
    var n = document.querySelector('cart-notification');
    return n && typeof n.renderContents === 'function' ? n : null;
  }

  /* Which section ids we ask Shopify to re-render alongside the add. */
  function wantedSections() {
    var list = [];
    if (bubbleEl()) list.push('cart-icon-bubble');
    var d = drawerEl();
    if (d) list.push(d.getAttribute('data-id') || 'cart-drawer');
    var n = notificationEl();
    if (n) list.push(n.getAttribute('data-id') || 'cart-notification');
    return list;
  }

  function swapBubble(html) {
    var el = bubbleEl();
    if (!el || !html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.getElementById('cart-icon-bubble');
      el.innerHTML = next ? next.innerHTML : el.innerHTML;
    } catch (e) {
      /* leave the old bubble in place */
    }
  }

  /* Inline confirmation used when the theme has no drawer or notification. */
  function confirmInline(button) {
    if (!button) return;
    var host = button.closest('form') || button.parentNode;
    if (!host) return;
    var existing = host.querySelector('[data-hs-added]');
    if (existing) {
      existing.classList.add('is-on');
      return;
    }
    var note = document.createElement('p');
    note.className = 'hs-added';
    note.setAttribute('data-hs-added', '');
    note.setAttribute('role', 'status');
    note.innerHTML =
      '<span aria-hidden="true">&#10003;</span> Added to your cart &middot; ' +
      '<a href="' + CART_URL + '">View cart</a>';
    host.appendChild(note);
    requestAnimationFrame(function () {
      note.classList.add('is-on');
    });
  }

  function setBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.dataset.hsLabel = button.innerHTML;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.innerHTML = 'Adding&hellip;';
    } else {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;
      if (button.dataset.hsLabel) button.innerHTML = button.dataset.hsLabel;
    }
  }

  function flashAdded(button) {
    if (!button) return;
    var original = button.dataset.hsLabel || button.innerHTML;
    button.classList.add('is-added');
    button.innerHTML = 'Added &#10003;';
    window.setTimeout(function () {
      button.classList.remove('is-added');
      button.innerHTML = original;
    }, 2000);
  }

  function onSubmit(event) {
    var form = event.currentTarget;
    var button = form.querySelector('[type="submit"]');

    /* Let the browser handle it if fetch isn't available. */
    if (typeof window.fetch !== 'function') return;

    event.preventDefault();

    var data = new FormData(form);
    var sections = wantedSections();
    if (sections.length) {
      data.append('sections', sections.join(','));
      data.append('sections_url', window.location.pathname);
    }

    setBusy(button, true);

    fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        setBusy(button, false);

        /* Shopify returns status/description on a real failure. */
        if (!result.ok || result.json.status) {
          var msg = result.json.description || result.json.message || '';
          if (msg) {
            window.alert(msg);
          } else {
            form.submit();
          }
          return;
        }

        var got = result.json.sections || {};
        swapBubble(got['cart-icon-bubble']);

        var drawer = drawerEl();
        var notification = notificationEl();

        if (drawer) {
          drawer.classList.remove('is-empty');
          try {
            drawer.renderContents(result.json);
          } catch (e) {
            confirmInline(button);
          }
        } else if (notification) {
          try {
            notification.renderContents(result.json);
          } catch (e) {
            confirmInline(button);
          }
        } else {
          confirmInline(button);
        }

        flashAdded(button);

        document.dispatchEvent(
          new CustomEvent('hs:cart:added', { detail: { item: result.json } })
        );
      })
      .catch(function () {
        /* Network or parsing trouble — fall back to the normal POST. */
        setBusy(button, false);
        form.submit();
      });
  }

  function alreadyHandled(form) {
    /* Dawn's own product form does its own AJAX add. */
    if (form.dataset.type === 'add-to-cart-form') return true;
    if (typeof form.closest === 'function' && form.closest('product-form')) return true;
    if (typeof form.closest === 'function' && form.closest('quick-add-bulk')) return true;
    return false;
  }

  function bind(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset[BOUND]) return;
      if (alreadyHandled(form)) return;
      form.dataset[BOUND] = '1';
      form.addEventListener('submit', onSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }

  /* Re-bind when the theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target);
  });
})();
